var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { casesActions } from 'src/redux/cases/casesActions';
import { getAutoPlay, getCollectionResults, getCollectionStatus } from 'src/redux/cases/casesSelectors';
import { getAutoPlayPermission, getUserInfo } from 'src/redux/auth/authSelectors';
import { checkIfCaseIsLocked } from 'src/redux/cases/helpers/caseHelpers';
import { useRouter } from 'src/shared/hooks/useRouting';
import { E_REQUEST_STATUS } from 'src/shared/types';
import { getI18n, getRealm } from 'src/redux/core/coreSelectors';
import { URL_PATH } from 'src/shared/constants';
import { isPageInactive, requestNotificationPermission, sendBrowserNotification } from 'src/shared/helpers/browserHelpers';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { replaceVariablesInString } from 'src/shared/helpers/stringHelpers';
import { useMount, useUpdate } from 'src/shared/hooks/useLifecycle';
import { checkIfCaseIsAlreadySeen } from 'src/ui/views/caseDetails/hooks';
import { NOTIFICATION_DESCRIPTION_KEY, NOTIFICATION_TITLE_KEY } from './constants';
export var useAutoSearchState = function () {
    var autoPlay = useSelector(getAutoPlay);
    var status = useSelector(getCollectionStatus);
    return { autoPlay: autoPlay, status: status };
};
export var useAutoSearchAction = function () {
    var dispatch = useDispatch();
    var resetCasesCollectionResult = function () { return dispatch(casesActions.resetCasesCollectionResult()); };
    var clearCurrentCase = function () { return dispatch(casesActions.clearCurrentCase()); };
    var updateAutoPlay = function (value) { return dispatch(casesActions.updateAutoPlay(value)); };
    var fetchAutoSearch = function () { return dispatch(casesActions.fetchAutoSearch()); };
    return { resetCasesCollectionResult: resetCasesCollectionResult, clearCurrentCase: clearCurrentCase, fetchAutoSearch: fetchAutoSearch, updateAutoPlay: updateAutoPlay };
};
export var useAutoSearchConfig = function () {
    var i18n = useSelector(getI18n);
    var hasAutoSearchPermission = useSelector(getAutoPlayPermission);
    return { i18n: i18n, hasAutoSearchPermission: hasAutoSearchPermission };
};
export var useAutoSearchNotification = function () {
    var organization = useSelector(getRealm);
    var i18n = useSelector(getI18n);
    var requestPermission = function () { return __awaiter(void 0, void 0, void 0, function () {
        var permission;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestNotificationPermission()];
                case 1:
                    permission = _a.sent();
                    return [2 /*return*/, permission];
            }
        });
    }); };
    var notifyNewCase = function () {
        var shouldNotify = isPageInactive();
        if (!shouldNotify) {
            return null;
        }
        var titleTemplate = getPropsByKeyPath(i18n, NOTIFICATION_TITLE_KEY) || '';
        var bodyTemplate = getPropsByKeyPath(i18n, NOTIFICATION_DESCRIPTION_KEY) || '';
        var title = replaceVariablesInString(titleTemplate, { organization: organization });
        var body = replaceVariablesInString(bodyTemplate, { organization: organization });
        var notification = sendBrowserNotification({
            title: title,
            body: body,
        });
        return notification;
    };
    return { requestPermission: requestPermission, notifyNewCase: notifyNewCase };
};
export var useAutoSearchPolling = function () {
    var routerEnhanced = useRouter();
    var _a = useAutoSearchState(), autoPlay = _a.autoPlay, status = _a.status;
    var _b = useAutoSearchAction(), resetCasesCollectionResult = _b.resetCasesCollectionResult, clearCurrentCase = _b.clearCurrentCase, fetchAutoSearch = _b.fetchAutoSearch, updateAutoPlay = _b.updateAutoPlay;
    var _c = useAutoSearchNotification(), requestPermission = _c.requestPermission, notifyNewCase = _c.notifyNewCase;
    var results = useSelector(getCollectionResults);
    var userInfo = useSelector(getUserInfo);
    var isEmpty = results.length === 0;
    var handledCaseIdRef = useRef(null);
    useMount(function () {
        handledCaseIdRef.current = null;
        resetCasesCollectionResult();
        clearCurrentCase();
    });
    useEffect(function () {
        var interval = null;
        var isLoading = status === E_REQUEST_STATUS.LOADING;
        var shouldFetch = !isLoading && isEmpty;
        if (!autoPlay) {
            return;
        }
        if (shouldFetch) {
            fetchAutoSearch();
        }
        if (isEmpty) {
            interval = setInterval(function () {
                fetchAutoSearch();
            }, 5000);
        }
        return function () {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [autoPlay, isEmpty]);
    useUpdate(function () {
        if (autoPlay && results && results.length > 0) {
            var unlockedCase = results.find(function (doc) { return !checkIfCaseIsLocked(userInfo, doc) && !checkIfCaseIsAlreadySeen(doc.id); });
            if (unlockedCase && handledCaseIdRef.current !== unlockedCase.id) {
                handledCaseIdRef.current = unlockedCase.id;
                notifyNewCase();
                routerEnhanced.push(URL_PATH.CASE_DETAIL_WITHOUT_PRODUCT(unlockedCase.id));
            }
        }
    }, [autoPlay, results, userInfo, routerEnhanced]);
    var handleUpdateAutoPlay = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!value) return [3 /*break*/, 2];
                    handledCaseIdRef.current = null;
                    return [4 /*yield*/, requestPermission()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    // Prevent using previous cases, if we start auto play again
                    resetCasesCollectionResult();
                    clearCurrentCase();
                    updateAutoPlay(value);
                    return [2 /*return*/];
            }
        });
    }); };
    return { autoPlay: autoPlay, results: results, status: status, updateAutoPlay: handleUpdateAutoPlay };
};
